import { Component } from "react";
import sadCat from "../gifs/sadcat.webp";
import { IErrorProps, IErrorState } from "../interfaces/Interfaces";

class ErrorBoundary extends Component<IErrorProps, IErrorState> {
  constructor(props: IErrorProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="flex flex-col justify-center items-center w-full h-screen bg-highlight">
          <h1 className="text-xl font-bold p-3 text-white">
            Uh oh! An error occured!
          </h1>
          <img src={sadCat} alt="Animated cat crying" />
          <div className="flex flex-row justify-center items-center">
            <h1 className="text-xl font-bold p-3 text-white">
              Please refresh the app...
            </h1>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
